import React from "react";
import Text from "../text";
import Image from "../image";
import WizardButton from "../wizard-button";
import ReadMoreButton from "../read-more-button";
import PropTypes from "prop-types";
import styles from "./wizard-card.module.scss";

const WizardCardDesktop = ({
  title,
  text,
  diagnosisType,
  visitType,
  wizardButtonText,
  readMoreUrl,
  readMoreText,
  symbolUrl,
  symbolAlt,
  mascotUrl,
  mascotAlt,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.desktopFirstColumn}>
        <div className={styles.symbolContainer}>
          <Image className={styles.symbol} src={symbolUrl} alt={symbolAlt} />
        </div>
        {diagnosisType && (
          <div className={styles.wizardButtonContainer}>
            <WizardButton
              visitType={visitType}
              diagnosisType={diagnosisType}
              text={wizardButtonText}
              className={styles.wizardButton}
            />
          </div>
        )}
      </div>
      <div className={styles.desktopSecondColumn}>
        <Text ellipsis={true} tag="h2" variant="h1">
          {title}
        </Text>
        <div className={styles.flex}>
          <div className={styles.desktopContentContainer}>
            <Text>{text}</Text>
            <div className={styles.desktopReadMoreContainer}>
              <ReadMoreButton
                textColor={"black"}
                url={readMoreUrl}
                text={readMoreText}
                className={styles.readMore}
              />
            </div>
          </div>
          <div className={styles.desktopMascotContainer}>
            <Image
              className={styles.desktopMascot}
              src={mascotUrl}
              alt={mascotAlt}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

WizardCardDesktop.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  diagnosisType: PropTypes.string.isRequired,
  visitType: PropTypes.string.isRequired,
  wizardButtonText: PropTypes.string.isRequired,
  readMoreUrl: PropTypes.string.isRequired,
  readMoreText: PropTypes.string.isRequired,
  symbolUrl: PropTypes.string.isRequired,
  symbolAlt: PropTypes.string.isRequired,
  mascotUrl: PropTypes.string.isRequired,
  mascotAlt: PropTypes.string.isRequired,
};

export default WizardCardDesktop;
